import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '../../atoms';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  Content,
  ButtonContainer,
  ImageContainer,
  StyledSplitScreenPromo,
} from './styles.js';

export const SplitScreenPromo = ({
  contentBgColor,
  imageBgColor,
  fontColor,
  image,
  link,
  imageFirst = false,
  content,
}) => {
  return (
    <StyledSplitScreenPromo>
      <Content fontColor={fontColor} bgColor={contentBgColor}>
        {content}
        {link && (
          <ButtonContainer>
            <LinkButton href={link.target}>{link.text}</LinkButton>
          </ButtonContainer>
        )}
      </Content>
      <ImageContainer bgColor={imageBgColor} imageFirst={imageFirst}>
        {image?.src && <ResponsiveImage {...image} />}
      </ImageContainer>
    </StyledSplitScreenPromo>
  );
};

SplitScreenPromo.displayName = 'SplitScreenPromo';

SplitScreenPromo.propTypes = {
  contentBgColor: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.object,
  imageBgColor: PropTypes.string,
  imageFirst: PropTypes.bool,
  link: PropTypes.shape({
    target: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  content: PropTypes.node,
};
